export var TimeGroupHeaderType;
(function (TimeGroupHeaderType) {
    TimeGroupHeaderType[TimeGroupHeaderType["Pinned"] = 0] = "Pinned";
    TimeGroupHeaderType[TimeGroupHeaderType["Today"] = 1] = "Today";
    TimeGroupHeaderType[TimeGroupHeaderType["Yesterday"] = 2] = "Yesterday";
    TimeGroupHeaderType[TimeGroupHeaderType["ThisWeek"] = 3] = "ThisWeek";
    TimeGroupHeaderType[TimeGroupHeaderType["LastWeek"] = 4] = "LastWeek";
    TimeGroupHeaderType[TimeGroupHeaderType["ThisMonth"] = 5] = "ThisMonth";
    TimeGroupHeaderType[TimeGroupHeaderType["LastMonth"] = 6] = "LastMonth";
    TimeGroupHeaderType[TimeGroupHeaderType["SpecificMonth"] = 7] = "SpecificMonth";
    TimeGroupHeaderType[TimeGroupHeaderType["SpecificYear"] = 8] = "SpecificYear";
    TimeGroupHeaderType[TimeGroupHeaderType["Older"] = 9] = "Older";
    TimeGroupHeaderType[TimeGroupHeaderType["OneMonthOlder"] = 10] = "OneMonthOlder";
    TimeGroupHeaderType[TimeGroupHeaderType["TwoMonthsOlder"] = 11] = "TwoMonthsOlder";
})(TimeGroupHeaderType || (TimeGroupHeaderType = {}));
//# sourceMappingURL=TimeGroupHeader.js.map